import { defineMessages } from 'react-intl';
import styled from 'styled-components';

import { useIntlContext } from '#src/contexts/intl/index.ts';

const messages = defineMessages({
  invalid: {
    defaultMessage: 'Invalid input',
  },
} as const);

const isMessageKey = (error: unknown): error is keyof typeof messages => {
  return typeof error === 'string' && error in messages;
};

type Props = {
  error?: keyof typeof messages | null | string;
  code?: boolean;
};

const StyledError = styled.span`
  color: var(--c-red-400);
`;

export const Error = ({ error, code }: Props) => {
  const { formatMessage } = useIntlContext();

  return error ? (
    <StyledError>
      {code && isMessageKey(error) ? formatMessage(messages[error]) : error}
    </StyledError>
  ) : null;
};
